export default __webpack_public_path__ + "static/media/bracol-logo.6d7d254a.png";